<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/";
  import Nav from "@/components/nav/";
  import Copy from "@/components/copy/"
  import Breadcrumb from "@/components/breadcrumb/"
  import Footer from "@/components/footer/"
  import Contact from "@/components/contact/";
  export default {
    data () {
      return {
        richText: '',
      };
    },
    mounted () {
      this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">临床验证技术中心</span></p>'
        //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
        + '<p>&nbsp;</p>'

        + '<div id="left" style="float:left ; width:70%; height:100%;">'
        + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify;line-height: 300%"><span style="margin-left: 36px; font-size: 16px">临床验证技术中心是转化医学上海设施的特色技术服务能力之一，主要为三大类疾病患者及健康受试者服务，定位于0期和I/II期临床试验，并将临床前研究的成果在转化型病房进行验证。总体量为300张临床研究型病床，设有内分泌转化医学病房、心血管转化医学病房、高血压转化医学病房、肿瘤血液转化医学病房以及代谢仓和I期临床研究型病房。</span></p>'
        + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify;line-height: 300%"><span style="margin-left: 36px; font-size: 16px">肿瘤血液病转化医学病房按照肿瘤疾病新药物与新型治疗\n' +
        '策略的特点，建设有综合性肿瘤临床研究病房，针对不同临\n' +
        '床研究需求提供相匹配的硬件和软件支持，包括医疗支持系\n' +
        '统、医疗的紧急抢救系统、临床药物试验药物投递和给药系\n' +
        '统、药代动力学和临床研究样本采集管理系统及基本生活支\n' +
        '持设备等硬件设施，可为相关临床试验顺利进行提供最优质\n' +
        '的硬件保障。</span></p>'
        + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify;line-height: 300%"><span style="margin-left: 36px; font-size: 16px">内分泌转化医学病房建立基于先进3D激光成像系统的全\n' +
        '息人体测量学数据采集病房，为精确评估人体体表及内脏器\n' +
        '官形态学提供依据。建立高精度可调式“代谢舱”和代谢产\n' +
        '物跟踪收集病房，可服务于肥胖、糖尿病、甲状腺功能异\n' +
        '常、骨代谢疾病和库欣综合症等多种代谢异常性疾病的临床\n' +
        '特征分析、发病机制探索、分型诊断及药物治疗疗效评估。</span></p>'

        // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 18px; ">联系人</span></p>'
        // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; color: #033d80; ">姓名：崔祎赟</span></p>'
        // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">邮箱：cyysjtu@sjtu.edu.cn</span></p>'
        // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">电话：17740823635</span></p>'
        + '</div>'


        + '<div id="right" style="float:left ; width:30%; height:100%;">'
        + '<p style="margin-left : 50px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/chenkang.jpg" style="float: center; width: 180px;  margin-right: 40px;"  border="0" vspace="0" alt=""></p>'
        + '<p style="margin-bottom : 20px;text-align: justify"><span style="font-size: 10px;"><b>负责人：陈康</b><br>' +
        '医学博士，上海交通大学医学院\n' +
        '附属瑞金医院心脏内科，副主任\n' +
        '医师，硕士研究生导师。瑞金医\n' +
        '院院办主任兼学科规划与大设施\n' +
        '管理处处长，上海市黄浦区青年\n' +
        '联合会常务委员，上海市黄浦区\n' +
        '科协委员。曾获得“上海市青年\n' +
        '岗位能手”、“上海市五四青年\n' +
        '奖章”，“上海市优秀青年医\n' +
        '师”，“第七届上海市医务青年\n' +
        '管理十杰”等荣誉。</span></p>'
        + '</div>'

        + '<p style="margin-left : 20px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jishuyanzheng_cn.jpg" style="float: left; width: 1200px;  margin-right: 20px;" border="0" vspace="0" alt=""></p>'

        + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">联系人</span></p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; ">林靖生</span></p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; ">邮箱: jasonlin@rjh.com.cn</span></p>'
        + '<p style="text-align: left; "><span style="font-size: 16px; ">电话: 18917762861</span></p>'
        + '<p>&nbsp;</p>'
    },
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-copy": Copy,
      "v-breadcrumb": Breadcrumb,
      "v-footer": Footer,
      "v-contact": Contact,
    }
  };
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
      @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
  }
  .b-richtext {
    text-align:left;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 10px;
      line-height: 24px;
    }
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Service13/index.vue